import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
// import { ReactiveFormsModule, FormsModule } from '@angular/forms';
// import { RouterModule } from '@angular/router';
import { NgProgressModule } from 'ngx-progressbar';
import { NgProgressHttpModule } from 'ngx-progressbar/http';
import { NgProgressRouterModule } from 'ngx-progressbar/router';
import { ToastrModule } from 'ngx-toastr';
import { TranslateModule } from '@ngx-translate/core';
import { BreadcrumbComponent } from './components/breadcrumb/breadcrumb.component';
import { PageHeaderComponent } from './components/page-header/page-header.component';
import { ErrorCodeComponent } from './components/error-code/error-code.component';
import { DisableControlDirective } from './directives/disable-control.directive';
import { SafeUrlPipe } from './pipes/safe-url.pipe';
import { ToObservablePipe } from './pipes/to-observable.pipe';
import { PDFExportModule } from '@progress/kendo-angular-pdf-export';
import { QRCodeModule } from 'angularx-qrcode';
import { MaterialModule } from './configuration/angular/material.module';
import { MtxGridModule } from '@ng-matero/extensions/grid';
import { BusinessInfoComponent } from 'app/components/business/businessInfo/businessInfo.component';
import { SharedCitationsComponent } from 'app/components/complaint/sharedCitations/sharedCitations.component';
import { SharedSiteVisitComponent } from 'app/components/complaint/sharedSiteVisit/sharedSiteVisit.component';
import { SharedEnclosedAreaComponent } from 'app/components/complaint/sharedEnclosedArea/sharedEnclosedArea.component';
import { BusinessCommentsComponent } from 'app/components/business/businessComments/businessComments.component';
import { SharedCorrespondenceComponent } from 'app/components/complaint/sharedCorrespondence/sharedCorrespondence.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { EditorModule } from '@progress/kendo-angular-editor';
import { InitialSiteVisitComponent } from 'app/components/complaint/sharedSiteVisit/initialSiteVisit/initialSiteVisit.component';
import { FollowupSiteVisitComponent } from 'app/components/complaint/sharedSiteVisit/followupSiteVisit/followupSiteVisit.component';
import { PostRemediationVisitComponent } from 'app/components/complaint/sharedSiteVisit/postRemediationVisit/postRemediationVisit.component';

const MODULES = [
  MaterialModule,
  NgProgressModule,
  NgProgressRouterModule,
  NgProgressHttpModule,
  ToastrModule,
  TranslateModule,
  PDFExportModule,
  EditorModule,

  QRCodeModule,
  MtxGridModule,
  
];
const COMPONENTS = [
  BreadcrumbComponent, 
  PageHeaderComponent, 
  ErrorCodeComponent,
  BusinessInfoComponent,
  SharedCitationsComponent,
  SharedSiteVisitComponent,
  SharedEnclosedAreaComponent,
  BusinessCommentsComponent,
  SharedCorrespondenceComponent,
  InitialSiteVisitComponent,
  FollowupSiteVisitComponent,
  PostRemediationVisitComponent
];
const COMPONENTS_DYNAMIC = [];
const DIRECTIVES = [DisableControlDirective];
const PIPES = [SafeUrlPipe, ToObservablePipe];

@NgModule({
    declarations: [...COMPONENTS, ...COMPONENTS_DYNAMIC, ...DIRECTIVES, ...PIPES],
    imports: [
        CommonModule,
        FormsModule,
        RouterModule,
        ReactiveFormsModule,
        ...MODULES
    ],
    exports: [
        CommonModule,
        FormsModule,
        RouterModule,
        ReactiveFormsModule,
        ...MODULES,
        ...COMPONENTS,
        ...DIRECTIVES,
        ...PIPES,
    ]
})
export class SharedModule {
  public constructor () {}
}
